/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:20:41
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 14:30:41
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
/* eslint import/no-unresolved: off */


const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/containers/Login'),
  },
    // require authenticate
  {
    path: '/',
    component: () => import('@/containers/Panel'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/my-account',
        name: 'MyAccount',
        component: () => import('@/containers/MyAccount'),
      },
      {
        path: '/paymentsandinvoices',
        name: 'PaymentsAndInvoices',
        component: () => import('@/containers/PaymentsAndInvoices'),
      },
      {
        path: '/recharges',
        name: 'Recharges',
        component: () => import('@/containers/Recharges'),
      },
      {
        path: '/billing',
        name: 'Billing',
        component: () => import('@/containers/Billing'),
      },
      {
        path: '/complains',
        name: 'Complains',
        component: () => import('@/containers/Complains'),
        props: true,
      },
      {
        path: '/services',
        name: 'Services',
        component: () => import('@/containers/Services'),
        props: true,
      },
      {
        path: '/occasionZone',
        name: 'OccasionZone',
        component: () => import('@/containers/OccasionZone'),
      },
      {
        path: '/help',
        name: 'Help',
        component: () => import('@/containers/Help'),
      },
    ],
  },
    // catch all redirect
    { path: '*', redirect: '/my-account' },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js